import { createApp } from "vue";
import { createPinia } from "pinia";
import "element-plus/dist/index.css";

import App from "./App.vue";
import router from "./router";
import i18n from "./locales";

// Import micro-interactions and animations
import "./assets/styles/animations.css";
// Import light mode overrides
import "./assets/styles/light-mode.css";

const app = createApp(App);

app.use(createPinia());
app.use(router);
app.use(i18n);

app.mount("#app");
